// City marks of the strategic view: one byte per hex in the overlay texture, from the snapshot's
// cities (each carries its own source ids). The shader tells the levels apart by thresholds.

import { HEX_COUNT } from '../../core/grid.ts';
import type { City } from '../../core/schema.ts';

export const MARK = { NONE: 0, CITY: 128, CAPITAL: 255 } as const;

/** Mark byte per hex; a capital wins over a city on the same hex. */
export function cityMarks(cities: readonly City[]): Uint8Array {
  const out = new Uint8Array(HEX_COUNT);

  for (const c of cities) {
    if (c.hex < 0 || c.hex >= HEX_COUNT) {
      continue;
    }
    out[c.hex] = Math.max(out[c.hex], c.capital ? MARK.CAPITAL : MARK.CITY);
  }

  return out;
}

/** Hexes whose mark stands on a city that carries no source id (truth rule 1). */
export function unsourcedMarks(cities: readonly City[]): number {
  const bare = new Set<number>();

  for (const c of cities) {
    if (c.hex < 0 || c.hex >= HEX_COUNT || c.sources.length > 0) {
      continue;
    }
    bare.add(c.hex);
  }

  return bare.size;
}
